
import React from 'react';
import { Tabs } from 'antd';
import DataVisualizationGrid from '../components/visualization/DataVisualizationGrid';


function DataVisualization() {
    const items = [
      {
        key: '1',
        label: 'Dataset 1',
        children: (
            <DataVisualizationGrid title="Dataset 1"/>
        ),
      },
      {
        key: '2',
        label: 'Dataset 2',
        children: (
            <DataVisualizationGrid title="Dataset 2"/>
        ),
      },
      {
        key: '3',
        label: 'Dataset 3',
        children: (
            <DataVisualizationGrid title="Dataset 3"/>
        ),
      },
    ];

    return (
        <>
            <div className="breadcrumb" style={{ textAlign: 'left', marginBottom: '50px' }}>
                <h1 style={{ color: '#102F10' }}>Home</h1>         
            </div>   

            <div>
                <Tabs tabPosition={"top"} type="card" size='large' items={items} className="custom-tabs data_visual_tabs"  style={{ flex: 1 }} />
            </div>
        </>
    );
}

export default DataVisualization;